import { P } from 'components'
import { getMetaContent } from 'helpers'
import { validateEmail } from 'helpers'
import useEnterSubmit from 'hooks/useEnterSubmit'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { ArrowLeft, Eye, EyeOff, User } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, FormGroup, Input, InputGroupText, Spinner } from 'reactstrap'
import {
  useCheckPasswordMutation,
  useLoginUserNewMutation,
  useSendOtpLoginMutation,
} from '../login-new/loginNewApiSlice'
import { login } from '../login/loginSlice'
import '../register-universal/register.css'
import './login-universal.css'
import Tnc from './Tnc'
import { recaptchaKey } from 'configs'
import useRecaptchaV3 from 'hooks/useRecaptchaV3'

const LoginStepTwo = () => {
  const recaptcha = useRecaptchaV3(recaptchaKey)
  const location = useLocation()
  const dataState = location.state
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const publicVersion = useSelector((s) => s.publicVersion)

  const [isShowPassword, setIsShowPassword] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const displayUsername =
    dataState?.identity ||
    dataState?.username ||
    sessionStorage.getItem('login_identity') ||
    ''

  useEffect(() => {
    if (dataState?.identity) {
      sessionStorage.setItem('login_identity', dataState.identity)
    }
  }, [dataState?.identity])

  useEffect(() => {
    const checkScreenSize = () => {
      const isMobileUA =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      const isSmallScreen = window.innerWidth < 768
      setIsMobile(isMobileUA || isSmallScreen)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const [errMsg, setErrMsg] = useState('')
  const [loginUser, { isLoading }] = useLoginUserNewMutation()
  const [payload, setPayload] = useState({})

  const [sendOtp, { isLoading: isLoadingSendOTP }] = useSendOtpLoginMutation()
  const [checkPassword, { isLoading: isLoadingCheckPassword }] =
    useCheckPasswordMutation()

  const browserHashLocalStorage = localStorage.getItem('browserHash')
  const browserFingerPrintLocalStorage =
    localStorage.getItem('browserFingerPrint')
  const browserCustomFingerPrintLocalStorage = localStorage.getItem(
    'browserCustomFingerPrint',
  )

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
  const [showContactCsButton, setShowContactCsButton] = useState(false)

  const handleSubmit = async () => {
    setIsLoadingSubmit(true)
    try {
      if (!dataState) {
        // window.location.replace('/homepage')
        window.location.replace('/')
        return
      }

      const loginPayload = {
        identity: dataState?.identity,
        deviceHash: dataState?.deviceHash,
        password: payload.identity,
        fcmToken: dataState?.fcmToken ?? '',
        packageName: dataState?.packageName || localStorage.getItem('PMB_packageName') || null,
        version: ` ${dataState?.mobileVersion ? `PM ${process.env.REACT_APP_VERSION} (${dataState?.mobileVersion})` : `PMB ${process.env.REACT_APP_VERSION}`} `,
        browserHash: browserHashLocalStorage ?? dataState?.browserHash,
        browserFingerPrint:
          browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
        browserCustomFingerPrint:
          browserCustomFingerPrintLocalStorage ??
          dataState?.browserCustomFingerPrint,
        'g-recaptcha-response': await recaptcha(),
      }

      localStorage.setItem('browserHash', loginPayload?.browserHash)
      localStorage.setItem(
        'browserFingerPrint',
        loginPayload?.browserFingerPrint,
      )
      localStorage.setItem(
        'browserCustomFingerPrint',
        browserCustomFingerPrintLocalStorage ??
          dataState?.browserCustomFingerPrint,
      )

      const res = await checkPassword(loginPayload)

      if (!res?.error) {
        if (dataState?.sendOtp) {
          fetchOtp('login')
          return
        } else {
          const loginData = {
            identity: dataState?.identity,
            deviceHash: dataState?.deviceHash,
            password: payload.identity,
            fcmToken: dataState?.fcmToken ?? '',
            packageName: dataState?.packageName || localStorage.getItem('PMB_packageName') || null,
            version: ` ${dataState?.mobileVersion ? `PM ${process.env.REACT_APP_VERSION} (${dataState?.mobileVersion})` : `PMB ${process.env.REACT_APP_VERSION}`} `,
            browserHash: browserHashLocalStorage ?? dataState?.browserHash,
            browserFingerPrint:
              browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
            browserCustomFingerPrint:
              browserCustomFingerPrintLocalStorage ??
              dataState?.browserCustomFingerPrint,
            'g-recaptcha-response': await recaptcha(),
          }
          const res = await loginUser(loginData)

          if (!res?.error) {
            dispatch(
              login({
                identity: dataState?.identity,
                ...res?.data,
              }),
            )
            // window.location.replace('/homepage')
            window.location.replace('/')
          } else {
            throw res
          }
        }
      } else {
        throw res
      }
    } catch (error) {
      enqueueSnackbar(
        error?.error?.data?.meta?.message ??
          error?.data?.meta?.message ??
          error?.data?.message ??
          error?.message ??
          'Gagal login!',
        { variant: 'error' },
      )
    } finally {
      setIsLoadingSubmit(false)
    }
  }

  const fetchOtp = async (status) => {
    try {
      setIsLoadingSubmit(true)
      let keyRecaptha = await recaptcha()
      const res5 = await sendOtp({
        identity: dataState?.identity,
        deviceHash: dataState?.deviceHash,
        type: status,
        channel: validateEmail(dataState?.identity) ? 'EMAIL' : 'WHATSAPP',
        browserHash: browserHashLocalStorage ?? dataState?.browserHash,
        browserFingerPrint:
          browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
        browserCustomFingerPrint:
          browserCustomFingerPrintLocalStorage ??
          dataState?.browserCustomFingerPrint,
        'g-recaptcha-response': keyRecaptha,
      })

      if (res5?.data?.meta?.error || res5?.error?.data?.meta?.error) {
        if (res5?.error?.data?.meta?.code === 'OTP02') {
          setShowContactCsButton(true)
        }
        enqueueSnackbar(
          res5?.data?.meta?.message ??
            res5?.data?.message ??
            res5?.error?.data?.meta?.message ??
            'Terjadi kesalahan.',
          {
            variant: 'error',
          },
        )
        return
      } else {
        navigate('/otp', {
          state: {
            type: status,
            identity: dataState?.identity,
            deviceHash: dataState?.deviceHash,
            countDown: res5?.data?.data?.expireTime,
            browserHash: browserHashLocalStorage ?? dataState?.browserHash,
            browserFingerPrint:
              browserFingerPrintLocalStorage ?? dataState?.browserFingerPrint,
            browserCustomFingerPrint:
              browserCustomFingerPrintLocalStorage ??
              dataState?.browserCustomFingerPrint,
            status: status,
            fcmToken: dataState?.fcmToken ?? '',
            mobileVersion: dataState?.mobileVersion ?? '',
            packageName: dataState?.packageName || localStorage.getItem('PMB_packageName') || '',
            password: payload.identity,
          },
        })
      }
      setShowContactCsButton(false)
    } catch (error) {
      enqueueSnackbar(
        error?.data?.meta?.message ??
          error?.data?.message ??
          error?.error?.data?.meta?.message ??
          'Terjadi kesalahan.',
        {
          variant: 'error',
        },
      )
    } finally {
      setIsLoadingSubmit(false)
    }
  }

  useEnterSubmit(handleSubmit, !payload?.identity || isLoading)

  // AUTO FOCUS
  const inputRef = useRef(null)
  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 100)
  }, [])

  return (
    <div className="centered-container">
      <div className="mobile-header" onClick={() => window.history.back()} data-testid="login-universal-back-button">
        <ArrowLeft size={20} className="chevron-icon" />
        {/* <P>Daftar akun</P> */}
      </div>

      <div
        className="card-wrapper"
        style={{
          borderRadius: 10,
          maxWidth: '600px',
        }}
      >
        <img
          src={getMetaContent('og:image')}
          alt={`${getMetaContent('og:title')} logo`}
          style={{
            marginBottom: 24,
            width: '100%',
            maxWidth: '150px',
            height: 'auto',
          }}
        />

        {displayUsername && (
          <div
            className="d-flex align-items-center justify-content-between px-3 py-2 mb-3 rounded"
            style={{
              backgroundColor: '#F9FAFB',
              border: '1px solid #EAECF0',
            }}
          >
            <div
              className="d-flex align-items-center gap-2"
              style={{ minWidth: 0 }}
            >
              <User size={16} color="#667085" style={{ flexShrink: 0 }} />
              <span
                className="text-dark fw-medium text-truncate"
                style={{ fontSize: '14px' }}
                data-testid="login-password-username-display"
              >
                {displayUsername}
              </span>
            </div>
            <span
              className="pointer ms-2 fw-medium"
              style={{
                fontSize: '13px',
                color: '#006386',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}
              onClick={() => navigate(-1, { replace: true })}
              data-testid="login-password-change-user-button"
            >
              Ganti
            </span>
          </div>
        )}

        {(() => {
          const FormTag = !isMobile ? 'form' : 'div'
          const formProps = !isMobile
            ? {
                onSubmit: (e) => {
                  e.preventDefault()
                  if (payload?.identity && !isLoading && !isLoadingSubmit) {
                    handleSubmit()
                  }
                },
              }
            : {}

          return (
            <FormTag {...formProps}>
              <div className="mt-2">
                <P size="regular">Masukkan password</P>

                {!isMobile && (
                  <input
                    type="text"
                    name="username"
                    id="username_hidden"
                    value={displayUsername || ''}
                    style={{
                      display: 'none',
                      position: 'absolute',
                      opacity: 0,
                      height: 0,
                      width: 0,
                    }}
                    tabIndex={-1}
                    autoComplete="username"
                    readOnly
                  />
                )}

                <FormGroup className="input-group mt-1">
                  <Input
                    innerRef={inputRef}
                    type={isShowPassword ? 'text' : 'password'}
                    name={!isMobile ? 'password' : 'password_no_autofill'}
                    id={!isMobile ? 'password' : 'password_no_autofill'}
                    autoComplete={
                      !isMobile ? 'current-password' : 'new-password'
                    }
                    data-1p-ignore={isMobile ? 'true' : undefined}
                    data-bwignore={isMobile ? 'true' : undefined}
                    data-testid="login-universal-password-input"
                    value={payload.identity ?? ''}
                    onChange={(e) => {
                      setErrMsg('')
                      setPayload((prevState) => ({
                        ...prevState,
                        identity: e?.target?.value,
                      }))
                    }}
                    placeholder="Masukkan password"
                    className="password-input"
                  />
                  <InputGroupText
                    className="toggle-password"
                    onClick={() => setIsShowPassword(!isShowPassword)}
                    data-testid="login-universal-show-password-toggle"
                  >
                    {isShowPassword ? (
                      <EyeOff size={15} style={{ cursor: 'pointer' }} />
                    ) : (
                      <Eye size={15} style={{ cursor: 'pointer' }} />
                    )}
                  </InputGroupText>
                </FormGroup>

                <div
                  className="mt-2"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    fetchOtp('resetPassword')
                  }}
                  data-testid="login-universal-forgot-password-link"
                >
                  <P size="regular" color={'#006386'}>
                    Lupa password?
                  </P>
                  <P color={'#B42318'} size="regular" testId="login-universal-error-message">
                    {errMsg}
                  </P>
                </div>
              </div>

              <div className="w-100 mt-3 d-flex flex-column gap-2">
                <Button
                  type={!isMobile ? 'submit' : 'button'}
                  disabled={!payload?.identity || isLoading || isLoadingSubmit}
                  className="w-100 d-flex justify-content-center align-items-center"
                  color="primary"
                  data-testid="login-universal-password-submit-button"
                  onClick={() => {
                    if (isMobile) {
                      handleSubmit()
                    }
                  }}
                >
                  {(isLoading || isLoadingSubmit) && (
                    <Spinner className="me-2" size="sm" color="light" />
                  )}
                  <P size="regular">Masuk</P>
                </Button>
              </div>
            </FormTag>
          )
        })()}
          {showContactCsButton ? (
            <Button
              disabled={isLoading || isLoadingSubmit}
              className="w-100 d-flex justify-content-center align-items-center mt-2"
              style={{ borderColor: '#D0D5DD' }}
              color="primary"
              outline
              onClick={() =>
                window.open(
                  `https://wa.me/${process.env.REACT_APP_WA_BOT_NUMBER || publicVersion?.data?.csNumber || '6285157570025'}`,
                  '_blank',
                )
              }
              data-testid="login-universal-contact-cs-button"
            >
              {isLoading && (
                <Spinner className="me-2" size="sm" color="light" />
              )}
              <P size="regular">Hubungi kami</P>
            </Button>
          ) : null}

          <div className="desktop-only mt-2">
            <Button
              disabled={isLoading || isLoadingSubmit}
              className="w-100 d-flex justify-content-center align-items-center"
              style={{ borderColor: '#D0D5DD' }}
              color="neutral"
              onClick={() => navigate(-1, { replace: true })}
            >
              {(isLoading || isLoadingSubmit) && (
                <Spinner className="me-2" size="sm" color="light" />
              )}
              <P size="regular">Kembali</P>
            </Button>
          </div>
        </div>
        {/* Footer */}
        <footer className="w-100 text-center py-3">
          <Tnc />
        </footer>
      </div>
  )
}

export default LoginStepTwo
